import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserDto, UsersService } from 'openapi/build';
import { KeycloakService } from 'src/app/services/keycloak/keycloak.service';
import { environment } from 'src/environments/environment';
import { PdfModalComponent } from './../popover/pdf-modal/pdf-modal/pdf-modal.component';

@Component({
  selector: 'mclu-repertoires-expert',
  templateUrl: './repertoires-expert.component.html',
  styleUrls: ['./repertoires-expert.component.scss'],
})
export class RepertoiresExpertComponent implements OnInit {
  public expertValue: string;
  public expertLink: string;
  public expertCarteLink: string;
  public carte: boolean = false;
  @Output() emitTypeCorp = new EventEmitter<string>();

  constructor(
    private userService: UsersService,
    private keycloakService: KeycloakService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    const user = this.keycloakService.getUserProfile();
    this.userService.userControllerGetUserByUsername(encodeURI(user.username))
      .toPromise()
      .then((user: UserDto) => {
        const expertType = (user.userAdministrateur || user.userProfessionnel).typeCorporation.type;
        console.log('expertType', expertType);
        if (expertType == "Notaire") {
          this.expertValue = 'notaires';
          this.expertLink = 'https://cotedivoire.eregulations.org/media/L%27ANNUAIRE%20TELEPHONIQUE%20DES%20NOTAIRES.pdf';
        } else if (expertType == "Géomètre-Expert") {
          this.expertValue = 'géomètres-experts';
          this.expertCarteLink = `${environment.apiBasePath + environment.apiFileBasePath}/piece-identite/visualiser/CARTE DE REGIONALISATION DES GEOMETRES EXPERTS AOUT 2024.pdf`;
          this.expertLink = `${environment.apiBasePath + environment.apiFileBasePath}/piece-identite/visualiser/TABLEAU DE ORDRE DES GEOMETRES EXPERTS AOUT 2024.pdf`;
          this.carte = true;
        } else if (expertType == "Banque") {
          this.expertValue = 'établissements financiers';
          this.expertLink = 'https://apbef-ci.net/paysage-bancaire/';
        } else if (expertType == "Promoteur") {
          this.expertValue = 'promoteurs';
          this.expertLink = 'https://cdn.yeclo.com/wp-content/uploads/2023/05/Liste-des-promoteurs-immobiliers-agrees-30.04.2023.pdf';
        } else if (expertType == "Architecte") {
          this.expertValue = 'architectes';
          this.expertLink = 'https://oarchitectes.ci/wp-content/uploads/2023/03/Tableau-de-lOrdre-des-architectes_1er-semestre-2023-1.pdf';
        } else {
          this.expertValue = undefined;
          this.expertLink = undefined;
        }
        this.emitTypeCorp.emit(this.expertValue);
        console.log('Type de compte', expertType);
      });
  }

  openPdf(link: string) {
    this.dialog.open(PdfModalComponent, {
      data: { pdfLink: link },
      width: '80vw',
      height: '80vh'
    });
  }
}
